import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import type { EmailDetail, EmailRecord, PaginatedResponse } from '@/lib/types'

interface EmailFilters {
  page?: number
  per_page?: number
  status?: string
  search?: string
  account?: string
  domain?: string
  from?: string
  to?: string
}

export function useEmails(params: EmailFilters) {
  return useQuery<PaginatedResponse<EmailRecord>>({
    queryKey: ['emails', params],
    queryFn: () => apiClient.get<PaginatedResponse<EmailRecord>>(endpoints.emails.list(params)),
  })
}

export function useEmail(id: string | null) {
  return useQuery<EmailDetail>({
    queryKey: ['emails', id],
    queryFn: () => apiClient.get<EmailDetail>(endpoints.emails.detail(id as string)),
    enabled: id !== null,
  })
}
